const magnets = [{ id: 1, type: "pivotMagnet", label: "Ghostop Magnet" }];

export { magnets };
